/** "#/spo?tab=diajukan" → "/spo?tab=diajukan"; selain tautan rute v1 → null. */
export function legacyHashToPath(hash: string): string | null {
  if (!hash.startsWith('#/')) return null;
  const path = hash.slice(1);
  return path === '/' ? '/' : path;
}
